import React from "react"
import fetch from "cross-fetch"
import { possibleTypes } from "@love-irish/graphql-schema"
import { InMemoryCache, ApolloClient } from "@apollo/client"
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs"

import { ApolloProvider } from "@apollo/client/react"

const isServer = typeof window === "undefined"
const csrfToken = () => document.querySelector("[name='csrf-token']").content

// Use UploadHttpLink instead of HttpLink to support file uploads
export const client = new ApolloClient({
  cache: new InMemoryCache({ possibleTypes }),
  link: new UploadHttpLink({
    uri: "/graphql",
    fetch,
    credentials: "include",
    headers: {
      "Apollo-Require-Preflight": "true",
      "X-CSRF-Token": !isServer && csrfToken(),
    },
  }),
  ssrMode: isServer,
  // Note: `typeDefs` (the SDL) was removed — Apollo only uses it for devtools introspection, not at
  // runtime, and importing it dragged the 2.7 MB schema.json + 394 KB schema.graphql into every page.
})

export const GraphqlProvider = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
